import { gql } from '@apollo/client'

export const rateCompanyBranch = gql`
mutation RateCompanyBranch($movePublicId: String!, $payload: CompanyRatingDto!) {
  rateCompanyBranch(movePublicId: $movePublicId, payload: $payload)
}
`
